import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/Board/usersNotInBoard/'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'

const userDefaults = {
  isInBoard: true,
}

const defaultBoardState = {
  userIds: [],
  usersById: {}
}

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        }
      }
    case ADD_ARRAY: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          userIds: [ ...state[action.payload.boardId].userIds ],
          usersById: { ...state[action.payload.boardId].usersById }
        }
      }

      action.payload.array.forEach(user => {
        newState[action.payload.boardId].userIds = addUniqueValueToArray({
          array: newState[action.payload.boardId].userIds,
          value: user.id
        })
        newState[action.payload.boardId].usersById[user.id] = {
          ...userDefaults,
          ...newState[action.payload.boardId].usersById[user.id],
          ...user
        }
      })

      return newState
    }
    default: return state
  }
}

export function addArray ({ boardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      boardId,
      array
    }
  }
}
